import BaseValidator from 'services/validations/base-validator';

class TotalMinExposureValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, lineupsQuantity} = this.dependencies;
        const items = stacking.getItems();

        let totalMinExposure = 0;
        items.forEach((item) => {
            const minExposure = item.getMinExposure();
            if (minExposure) {
                totalMinExposure += Number(minExposure);
            }
        });

        if (lineupsQuantity < totalMinExposure) {
            this.addError(`Total min quantity of lineups cannot be more than ${lineupsQuantity}.`);
        }
    }
}

export default TotalMinExposureValidator;
